var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { faEye } from "@fortawesome/free-solid-svg-icons";
import {} from "@/api/invocations";
import { getAppRoot } from "@/onload";
import {} from "./types";
/**
 * Request and return invocations for the given workflow (and current user) from server
 */
function getData(offset, limit, search, sort_by, sort_desc, extraProps) {
    return __awaiter(this, void 0, void 0, function* () {
        // extra props will be Record<string, Invocation>; get array of invocations
        const data = Object.values(extraProps !== null && extraProps !== void 0 ? extraProps : {});
        const totalMatches = data.length;
        return [data, totalMatches];
    });
}
/**
 * Declare columns to be displayed
 */
const fields = [
    {
        key: "expand",
        title: null,
        type: "expand",
    },
    {
        key: "view",
        title: "View",
        type: "button",
        icon: faEye,
        handler: (data) => {
            const url = `${getAppRoot()}workflows/invocations/${data.id}`;
            window.open(url, "_blank");
        },
        converter: () => "",
    },
    {
        key: "history_id",
        title: "History",
        type: "history",
    },
    {
        key: "create_time",
        title: "Invoked",
        type: "date",
    },
    {
        key: "state",
        title: "State",
        type: "helptext",
        converter: (data) => {
            const invocation = data;
            return `galaxy.invocations.states.${invocation.state}`;
        },
    },
];
/**
 * Grid configuration
 */
const gridConfig = {
    id: "invocations-batch-grid",
    fields: fields,
    getData: getData,
    plural: "Workflow Invocations",
    sortBy: "create_time",
    sortDesc: true,
    sortKeys: [],
    title: "Workflow Invocations in Batch",
};
export default gridConfig;
